import React from 'react';

import {
  Card,
  CardContent,
  Typography,
  Box,
} from '@material-ui/core';

import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Tooltip,
  Legend,
} from 'recharts';

import { ActionChartData } from '../types';
import LegendItem from './legend-item';

interface Props {
  data: ActionChartData[];
      period: 'week' | 'month';
}

const COLORS = [
  '#22C55E', // Added
  '#3B82F6', // Modified
  '#EF4444', // Deleted
];

const ActionPieChart = ({ data ,period}: Props) => {

    const total = data.reduce((sum, item) => sum + item.value, 0);

    const getPercentage = (value: number) =>
    ((value / total) * 100).toFixed(1);

  return (
    <Card
      elevation={3}
      style={{
        borderRadius: 16,
        height: '100%',
      }}
    >
      <CardContent>

      <Typography
    variant="h6"
    style={{
        fontWeight:700,
        marginBottom:20,
    }}
>
    Action Distribution
</Typography>

<Typography
    variant="body2"
    color="textSecondary"
    style={{marginBottom:10}}
>
    {period === "week"
        ? "Last 7 Days"
        : "Last 30 Days"}
</Typography>

        <Box display="flex" alignItems="center">

        {/* Chart */}
        <Box
            flex={1}
            height={320}
            position="relative"
        >

            <ResponsiveContainer>

            <PieChart>

                <Pie
                data={data}
                dataKey="value"
                nameKey="name"
                innerRadius={70}
                outerRadius={105}
                paddingAngle={4}
                >
                {data.map((item, index) => (
                    <Cell
                    key={item.name}
                    fill={COLORS[index]}
                    />
                ))}
                </Pie>

                <Tooltip />

            </PieChart>

            </ResponsiveContainer>

            {/* Center Text */}

            <Box
            style={{
                position: 'absolute',
                left: '50%',
                top: '50%',
                transform: 'translate(-50%, -50%)',
                textAlign: 'center',
                pointerEvents: 'none',
            }}
            >
            <Typography
                variant="h5"
                style={{ fontWeight: 700 }}
            >
                {Intl.NumberFormat('en', {
                notation: 'compact',
                }).format(total)}
            </Typography>

            <Typography
                variant="caption"
                color="textSecondary"
            >
                Operations
            </Typography>
            </Box>

        </Box>

        {/* Legend */}

        <Box
            width={220}
            ml={2}
        >
            {data.map((item, index) => (
            <LegendItem
                key={item.name}
                color={COLORS[index]}
                title={item.name}
                value={item.value}
                percentage={getPercentage(item.value)}
            />
            ))}
        </Box>

        </Box>
      </CardContent>

    </Card>
  );
};

export default ActionPieChart;